// src/app/[locale]/(public)/(marketing)/how-it-works/HowItWorksCta.tsx
"use client";

import { Link } from "@/i18n/navigation";
import { useAuth } from "@/context/AuthContext";
import { isRegistrationEnabled } from "@/lib/feature-flags";

interface HowItWorksCtaProps {
  label: string;
  labelWaitlist: string;
}

export default function HowItWorksCta({ label, labelWaitlist }: HowItWorksCtaProps) {
  const { isAuthenticated } = useAuth();
  const authed = isAuthenticated();
  const href = authed ? "/build-preset" : "/register";
  const displayLabel = authed || isRegistrationEnabled ? label : labelWaitlist;

  return (
    <Link
      href={href}
      className="inline-block px-8 py-4 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 rounded-xl font-semibold transition-all shadow-lg shadow-pink-500/25 text-white"
    >
      {displayLabel}
    </Link>
  );
}
